import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import TimeAgo from 'react-timeago';

import Auth from '../Authentication/Auth';
import Api from '../../Services/Api';
import FuelMetersList from './FuelMetersList';


class FuelTankOverview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fuelTank: {
        measured: this.props.fuelTank.measured,
        calculatedQuantity: this.props.fuelTank.calculatedQuantity,
      }
    };

    this.handleFillup = this.handleFillup.bind(this);
  }

  calculateFuelLevel(quantity) {
    if (this.props.fuelTank.capacity <= 0) {
      return 0;
    }

    return (quantity / this.props.fuelTank.capacity) * 100;
  }

  urgencyLevelClass(fuelLevelPercent) {
    let urgencyLevel = 'urgency';
    if (fuelLevelPercent >= 90 && fuelLevelPercent <= 100) { urgencyLevel = 'urgency0'; } else
    if (fuelLevelPercent >= 75 && fuelLevelPercent < 90) { urgencyLevel = 'urgency1'; } else
    if (fuelLevelPercent >= 50 && fuelLevelPercent < 75) { urgencyLevel = 'urgency2'; } else
    if (fuelLevelPercent >= 25 && fuelLevelPercent < 50) { urgencyLevel = 'urgency3'; } else
    if (fuelLevelPercent >= 0 && fuelLevelPercent < 25) { urgencyLevel = 'urgency4'; }

    return urgencyLevel;
  }

  postFillup() {
    const endPoint = `v1/fbos/${this.props.fboId}/fuel_trucks/${this.props.ownerId}/fuel_tanks/${this.props.fuelTank.id}`;

    this.request = Api.get(endPoint, {
      method: 'PUT',
      body: JSON.stringify({
        measured: this.props.fuelTank.capacity,
        calculatedQuantity: this.props.fuelTank.capacity,
        measuredAt: new Date(),
        calculatedAt: new Date(),
      }),
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': Auth.getBearerToken(),
      },
    }, false).then((response) => {
      const fuelTank = this.state.fuelTank;
      fuelTank.measured = response.fuelTank.measured;
      fuelTank.calculatedQuantity = response.fuelTank.calculatedQuantity;
      this.setState({ fuelTank });
    }).catch((error) => {
      this.refs.notificationSystem.addNotification({
        message: `Unable to create Order ${error.message}`,
        level: 'error',
        position: 'bc',
      });
    });
  }

  handleFillup() {
    this.postFillup();
  }

  renderFuelTruck(editState) {
    return (
      <span>
        <Link
          to={{ pathname:`/fueltrucks/fueltank/${this.props.fuelTank.id}/edit`, state: editState }}
          className="fuel-item-settings"
          params={{ fboId: this.props.fboId, fuelTruckId: this.props.ownerId, fuelTank: this.props.fuelTank }}>
          Settings
        </Link>

        <button type="button" onClick={this.handleFillup} className="btn btn-small btn-primary-outline">
          Top Off
        </button>
      </span>
    );
  }

  render() {
    const currentQuantity = this.state.fuelTank.calculatedQuantity;
    const levelTypeLabel = 'Estimated';

    const fuelLevelPercent = `${Math.round(this.calculateFuelLevel(currentQuantity))}`;
    const urgencyLevelClassNames = `fuel-level-chart  ${this.urgencyLevelClass(fuelLevelPercent)}`;

    const editState = {
      fuelTank: this.props.fuelTank,
      fboId: this.props.fboId,
      ownerId: this.props.ownerId,
      ownerType: this.props.ownerType,
    };

    if (this.props.ownerType === 'fuelfarm') {
      editState.fuelFarmId = this.props.ownerId;
    } else if (this.props.ownerType === 'fueltruck') {
      editState.fuelTruckId = this.props.ownerId;
    }

    return (
      <article className="fuel-item">
        <div className="fuel-item-content">
          <div className={urgencyLevelClassNames}>
            <div className='fuel-level' style={{ height: `${fuelLevelPercent}%` }}>
              <div className="fuel-level-label">{ levelTypeLabel } { fuelLevelPercent }%</div>
            </div>
          </div>
          <h4>{ this.props.ownerName }</h4>
          <h5>{ this.props.fuelTank.fuelType.name }</h5>
          { this.props.fuelTank.fuelMeters &&
            <FuelMetersList fuelMeters={this.props.fuelTank.fuelMeters}/>
          }
          <p>{ currentQuantity } / { this.props.fuelTank.capacity } Gal Capacity</p>
          { (this.props.ownerType === 'fuelfarm' && this.props.fuelTank.measuredAt) &&
            <p>Measured: {this.props.fuelTank.measured}&quot; - {<TimeAgo date={this.props.fuelTank.measuredAt} />} </p>
          }
          { (this.props.ownerType === 'fuelfarm') ?
            <Link
              to={{ pathname:`/fuelfarm/fueltank/${this.props.fuelTank.id}/edit`, state: editState }}
              className="fuel-item-settings"
              params={{ fboId: this.props.fboId, fuelFarmId: this.props.ownerId, fuelTank: this.props.fuelTank }}>
              Settings
            </Link>
          :
            this.renderFuelTruck(editState)
          }
        </div>
      </article>
    );
  }
}

FuelTankOverview.propTypes = {
  fboId: PropTypes.number.isRequired,
  ownerId: PropTypes.number.isRequired,
  ownerType: PropTypes.string.isRequired,
  ownerName: PropTypes.string.isRequired,
  fuelTank: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    capacity: PropTypes.number.isRequired,
    measured: PropTypes.number.isRequired,
    measuredAt: PropTypes.string.isRequired,
    radius: PropTypes.number.isRequired,
    length: PropTypes.number.isRequired,
    calculatedQuantity: PropTypes.number.isRequired,
    fuelType: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default FuelTankOverview;



// WEBPACK FOOTER //
// ./src/Containers/FuelTanks/FuelTankOverview.js